/** @file String key of what the update order depends on per bone: parent, sibling order, inherit, kind. */
import type { Doc } from '@pose2d/format/types';

// One JSON array per bone: a concatenation of JSON values parses back one way only, so no id, parent or enum value
// can be mistaken for a separator or for the null parent (ids are not re-validated by the compiler).
/** Changes only when the hierarchy changes (not on setup transform, length, name or ui edits). */
export function hierarchyKey(bones: Doc['bones']): string {
  let key = '';
  for (const [id, b] of Object.entries(bones)) key += JSON.stringify([id, b.parent, b.siblingIndex, b.inherit, b.kind ?? null]);
  return key;
}
